import React from 'react';
import './ViewTermsModal.css';

const ViewTermsModal = ({ coupon, onClose }) => {
  if (!coupon) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Terms & Conditions - {coupon.code}</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="modal-content">
          <div className="terms-content">
            {coupon.terms || 'No terms and conditions specified for this coupon.'}
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewTermsModal;

